<roots-page-header
  [toolTip]="_config.toolTip"
  [title]="_config.title"
  [loading]="_config.loading"
  [items]="actionButtons"
  (refresh)="refresh($event)"
  (actionListClicked)="topMenuActionsClicked($event)"
  >
</roots-page-header>
<section class="report-query-panel">
  <div class="report-query-heading"><mat-icon>date_range</mat-icon><div><h2>Report date range</h2><p>Choose the period to include in this report.</p></div></div>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Date range</mat-label>
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
      <input matStartDate [min]="minDate" formControlName="start" placeholder="Start date" (dateChange)="changeEvent($event)">
      <input matEndDate [max]="maxDate" formControlName="end" placeholder="End date" (dateChange)="changeEndEvent($event)">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
    @if (range.controls.start.hasError('matStartDateInvalid')) { <mat-error>Invalid start date</mat-error> }
    @if (range.controls.end.hasError('matEndDateInvalid')) { <mat-error>Invalid end date</mat-error> }
  </mat-form-field>
</section>
<roots-table
      [tableColumns]="_config.displayedColumns"
      [dataSource]="_config.dataSource"
      [filter]="_config.message"
      [csv]="_config.title"
      [items]="items"
      (actionsClicked)="actionsClicked($event)"
      [clickingEnabled]="true">
    </roots-table>
